module.exports = __webpack_public_path__ + "static/media/(V)_MG_6113_-_capim_dourado_-_bijuterias.d7ae9b44.jpg";